import React from 'react';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Stack,
  Typography,
} from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { dataGridWithCellBordersClass } from '@shared/styles';

interface ItemError {
  reason: string;
  gtinCode?: string;
  mgItemNumber?: number;
  supplierId?: number;
}

interface Props {
  items: ItemError[];
}

const columns: GridColDef[] = [
  {
    field: 'mgItemNumber',
    width: 150,
  },
  {
    field: 'supplierId',
    width: 150,
  },
  {
    field: 'gtinCode',
    width: 150,
  },
  {
    field: 'reason',
    width: 200,
  },
];

export const ImportItemApiErrors: React.FC<Props> = ({ items }) => {
  const t = useAppTFunction();
  return (
    <Alert severity="error">
      <Stack gap={2} alignItems="center">
        <Typography>{t('campaign.error.notValidatedInfo')}</Typography>
        <Accordion sx={{ width: '100%' }}>
          <AccordionSummary>
            {items.length === 1
              ? t('markup.messages.rows.singular')
              : t('markup.messages.rows.plural')}
          </AccordionSummary>
          <AccordionDetails sx={{ maxWidth: '700px' }}>
            <DataGridPremium<ItemError>
              sx={{ width: '100%' }}
              columns={columns}
              rows={items}
              getRowId={(row) => `${row.mgItemNumber}${row.gtinCode}${row.supplierId}`}
              hideFooter
              className={dataGridWithCellBordersClass}
            />
          </AccordionDetails>
        </Accordion>
      </Stack>
    </Alert>
  );
};
